import { getRequestTransportErrorMessage } from '#/utils/requestError';

export function getWorkOrderApiErrorMessage(error, fallback = '操作失敗') {
  const transportMessage = getRequestTransportErrorMessage(error);
  if (transportMessage) {
    return transportMessage;
  }

  const data = error?.response?.data;
  const code = data?.code;

  if (code === 'RESOURCE_VERSION_CONFLICT') {
    return data?.message || '資料已被他人修改，請重新載入後再試';
  }

  if (code === 'WORK_ORDER_AMENDMENT_PARENT_CHANGED') {
    return data?.message || '工單已變更，請重新載入異動單後再試';
  }

  if (code === 'UPDATED_AT_REQUIRED') {
    return data?.message || '缺少更新時間，請重新載入後再試';
  }

  if (code === 'WORK_ORDER_NOT_FOUND' || code === 'RESOURCE_NOT_FOUND') {
    return data?.message || '找不到工單資料';
  }

  if (data?.message) {
    return data.message;
  }

  if (code) {
    return `${fallback}（${code}）`;
  }

  return fallback;
}

export function isWorkOrderVersionConflict(error) {
  return error?.response?.data?.code === 'RESOURCE_VERSION_CONFLICT';
}
